import { v4 as uuidv4 } from "uuid";
import { getMetricsData } from "./ecs-cluster-template";

const monitoringMetricsData = {
  metrics: [
    {
      Label: "CPU Utilization",
      MetricName: "CPUUtilization",
      Namespace: "AWS/EC2",
    },
    {
      Label: "CPU Surplus Credit Balance",
      MetricName: "CPUSurplusCreditBalance",
      Namespace: "AWS/EC2",
    },
    {
      Label: "Metadata No Token",
      MetricName: "MetadataNoToken",
      Namespace: "AWS/EC2",
    },
    {
      Label: "Disk Write Ops",
      MetricName: "DiskWriteOps",
      Namespace: "AWS/EC2",
    },
    {
      Label: "CPU Credit Usage",
      MetricName: "CPUCreditUsage",
      Namespace: "AWS/EC2",
    },
    {
      Label: "Status Check Failed System",
      MetricName: "StatusCheckFailed_System",
      Namespace: "AWS/EC2",
    },
    {
      Label: "Disk Read Bytes",
      MetricName: "DiskReadBytes",
      Namespace: "AWS/EC2",
    },
    {
      Label: "Network In",
      MetricName: "NetworkIn",
      Namespace: "AWS/EC2",
    },
    {
      Label: "Network Out",
      MetricName: "NetworkOut",
      Namespace: "AWS/EC2",
    },
    {
      Label: "Status Check Failed Instance",
      MetricName: "StatusCheckFailed_Instance",
      Namespace: "AWS/EC2",
    },
    {
      Label: "CPU Surplus Credits Charged",
      MetricName: "CPUSurplusCreditsCharged",
      Namespace: "AWS/EC2",
    },
    {
      Label: "CPU Credit Balance",
      MetricName: "CPUCreditBalance",
      Namespace: "AWS/EC2",
    },
  ],
};

export const monitoringMetric = () => {
  let monitoringMetricList = {
    metrics: [],
  };

  monitoringMetricsData &&
    monitoringMetricsData.metrics.forEach((data) => {
      const metricData = {
        ...data,
      };
      metricData.Id = data.Id ? data.Id : uuidv4();
      monitoringMetricList.metrics.push(metricData);
    });
  return monitoringMetricList;
};

// export const monitoringMetric = async () => {
//   let metricsData = await getStorage("APP_MONITORING");
//   if (!metricsData) {
//     const template = ecsClusterManifest();
//     metricsData = template.ManifestTemplateContent.monitoring;
//   }
//   return metricsData;
// };

export const checkCloudWatchUserExistData = {
  CFNPath: "default",
  ConfigExists: true,
  LaunchCFN: false,
  Package: "AmazonCloudWatchAgent",
};

export const detectCloudWatchAgentData = {
  PackageName: "cloudwatchagent",
  Version: "1.0.0",
  Status: "Running",
  IsInstalled: true,
};

export const getMonitoringMetricData = (config) => {
  const url = config.url.split("?");
  let test = decodeURIComponent(url[1]).split("&");
  let data = {};
  test.forEach((val) => {
    let x = val.split("=");
    data[x[0]] = x[1];
  });
  return getMetricsData(data);
};
